import React from 'react';
import { useI18n } from '../../../../../../data/hooks/i18nHooks';
import { useScheduleTags } from '../../../../../../data/hooks/schedule/useScheduleTags';
import { useSelectableSessions } from '../../../../../../data/hooks/schedule/useSelectableSessions';
import { useTasks } from '../../../../../../data/hooks/schedule/useTasks';
import { useIsMobile } from '../../../../../../data/hooks/ui/useIsMobile';
import { EVENT_SCHEDULE_TAB_MINE, EVENT_SCHEDULE_TAB_PROGRAM, EVENT_SCHEDULE_TAB_SEARCH, EVENT_SCHEDULE_TAB_TAGGED, EVENT_SCHEDULE_TAB_TASKS } from '../../../schedule-header-tabs';
import TaskIcon from '../../../../../../resources/icons/hand-regular.svg';
import styles from './ScheduleTabs.module.scss';
import Tab from './Tab';
import FilterIcon from './filter-solid.svg';
import SearchIcon from './magnifying-glass-solid.svg';

function ScheduleTabs(props) {
    const { eventId, tab, onChange } = props,
        i18n = useI18n(),
        hasSelectableSessions = useSelectableSessions(eventId).length > 0,
        myProgram = hasSelectableSessions,
        hasTasks = useTasks(eventId).length > 0,
        hasTags = useScheduleTags(eventId).length > 0,
        isMobile = useIsMobile();

    if (!myProgram && !hasTasks && !hasTags) return null;

    return (
        <div className={[styles.ScheduleTabs, isMobile ? styles.mobile : ''].join(' ')}>
            <Tab className={styles.labeled} selected={tab == EVENT_SCHEDULE_TAB_PROGRAM} onClick={() => onChange(EVENT_SCHEDULE_TAB_PROGRAM)}>
                {i18n['label.program']}
            </Tab>
            {myProgram ? (
                <Tab className={styles.labeled} selected={tab == EVENT_SCHEDULE_TAB_MINE} onClick={() => onChange(EVENT_SCHEDULE_TAB_MINE)}>
                    {i18n['label.my.program']}
                </Tab>
            ) : null}
            {hasTasks ? (
                <Tab selected={tab == EVENT_SCHEDULE_TAB_TASKS} onClick={() => onChange(EVENT_SCHEDULE_TAB_TASKS)}>
                    <TaskIcon />
                </Tab>
            ) : null}
            {hasTags ? (
                <Tab selected={tab == EVENT_SCHEDULE_TAB_TAGGED} onClick={() => onChange(EVENT_SCHEDULE_TAB_TAGGED)}>
                    <FilterIcon />
                </Tab>
            ) : null}
            <Tab selected={tab == EVENT_SCHEDULE_TAB_SEARCH} onClick={() => onChange(EVENT_SCHEDULE_TAB_SEARCH)}>
                <SearchIcon />
            </Tab>
        </div>
    );
}

export default ScheduleTabs;
